/**
 * Mobile header: hamburger drawer + collapsible accordion.
 * Venue CEs are brittle on Dawn; this owns the interactions.
 */
(function () {
  var DRAWER_SEL = 'l-header-drawer-mobile';
  var BTN_ID = 'mobileToggleHamburger';
  var MODAL = 'header';

  function drawer() {
    return document.querySelector(DRAWER_SEL);
  }

  function btn() {
    return document.getElementById(BTN_ID);
  }

  function lock() {
    if (typeof l_setupVariablesBeforeOpenModal === 'function') l_setupVariablesBeforeOpenModal();
    if (typeof l_lockBodyScroll === 'function') l_lockBodyScroll(MODAL);
    else document.documentElement.classList.add('js-block-page', 'js-block-page-header');
  }

  function unlock() {
    if (typeof l_unLockBodyScroll === 'function') l_unLockBodyScroll(MODAL);
    else {
      document.documentElement.classList.remove('js-block-page-header');
      if (![].some.call(document.documentElement.classList, function (c) { return c.indexOf('js-block-page-') === 0; })) {
        document.documentElement.classList.remove('js-block-page');
      }
    }
  }

  function isOpen(el) {
    return el && el.classList.contains('is-active');
  }

  function openMenu() {
    var el = drawer();
    var toggle = btn();
    if (!el || !toggle) return;

    toggle.classList.add('is-active');
    toggle.setAttribute('aria-expanded', 'true');
    lock();
    el.classList.remove('l-hidden');
    void el.offsetWidth;
    el.classList.add('is-active');
    document.addEventListener('click', onOutside, true);
    document.addEventListener('keyup', onEscape, true);
    if (typeof l_trapFocus === 'function') {
      var inner = el.querySelector('[data-inner]');
      if (inner) l_trapFocus(inner);
    }
  }

  function closeMenu() {
    var el = drawer();
    var toggle = btn();
    if (!el) return;

    if (toggle) {
      toggle.classList.remove('is-active');
      toggle.setAttribute('aria-expanded', 'false');
    }
    unlock();
    el.classList.remove('is-active');
    window.setTimeout(function () {
      if (!isOpen(el)) el.classList.add('l-hidden');
    }, 400);
    document.removeEventListener('click', onOutside, true);
    document.removeEventListener('keyup', onEscape, true);
    if (typeof l_removeTrapFocus === 'function') l_removeTrapFocus(toggle);
  }

  function toggleMenu(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    }
    var el = drawer();
    if (!el) return;
    if (isOpen(el)) closeMenu();
    else openMenu();
  }

  function onOutside(event) {
    var el = drawer();
    var toggle = btn();
    if (!el || !isOpen(el)) return;
    var inner = el.querySelector('[data-inner]');
    var t = event.target;
    if (inner && inner.contains(t)) return;
    if (toggle && toggle.contains(t)) return;
    closeMenu();
  }

  function onEscape(event) {
    if (event.code === 'Escape' || event.key === 'Escape') closeMenu();
  }

  function directChild(parent, selector) {
    if (!parent) return null;
    var nodes = parent.children;
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].matches && nodes[i].matches(selector)) return nodes[i];
    }
    return null;
  }

  function collapseTab(tab) {
    var trigger = directChild(tab, '[data-trigger], button');
    var content = directChild(tab, '[data-content]');
    if (!content) return;
    tab.classList.remove('is-expanded');
    tab.classList.add('is-collapsed');
    tab.removeAttribute('open');
    content.style.height = content.scrollHeight + 'px';
    void content.offsetHeight;
    content.style.height = '0px';
    content.setAttribute('aria-hidden', 'true');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function expandTab(tab) {
    var trigger = directChild(tab, '[data-trigger], button');
    var content = directChild(tab, '[data-content]');
    if (!content) return;
    content.removeAttribute('hidden');
    content.style.display = 'block';
    tab.classList.add('is-expanded');
    tab.classList.remove('is-collapsed');
    tab.setAttribute('open', 'true');
    content.style.height = 'auto';
    var h = content.scrollHeight;
    content.style.height = '0px';
    void content.offsetHeight;
    content.style.height = h + 'px';
    content.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    var onEnd = function (event) {
      if (event.target !== content) return;
      content.removeEventListener('transitionend', onEnd);
      if (tab.classList.contains('is-expanded')) {
        content.style.height = 'auto';
      }
    };
    content.addEventListener('transitionend', onEnd);
    window.setTimeout(function () {
      if (tab.classList.contains('is-expanded')) content.style.height = 'auto';
    }, 450);
  }

  function toggleTab(tab, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    }
    var open = tab.classList.contains('is-expanded');
    if (open) {
      collapseTab(tab);
      return;
    }

    // Accordion: close sibling tabs at the same level
    var parent = tab.parentElement;
    if (parent) {
      [].forEach.call(parent.children, function (sib) {
        if (sib !== tab && sib.matches && sib.matches('l-collapsible-tab.is-expanded')) {
          collapseTab(sib);
        }
      });
    }
    expandTab(tab);
  }

  function bindCollapsibles() {
    var el = drawer();
    if (!el) return;

    el.querySelectorAll('l-collapsible-tab').forEach(function (tab) {
      if (tab.dataset.aCollapseBound === '1') return;
      tab.dataset.aCollapseBound = '1';

      var trigger = directChild(tab, '[data-trigger], button.l-headerDrawerMb__collapsible-button, button');
      var content = directChild(tab, '[data-content]');
      if (!trigger || !content) return;

      content.removeAttribute('hidden');
      content.style.overflow = 'hidden';
      content.style.height = '0px';
      content.setAttribute('aria-hidden', 'true');
      tab.classList.add('is-collapsed');
      tab.classList.remove('is-expanded');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('type', 'button');

      // Capture so Venue l-collapsible-tab CE cannot swallow / double-fire
      trigger.addEventListener(
        'click',
        function (event) {
          toggleTab(tab, event);
        },
        true
      );
    });
  }

  function bindHamburger() {
    var toggle = btn();
    if (!toggle || toggle.dataset.aHeaderMobileBound === '1') return;
    toggle.dataset.aHeaderMobileBound = '1';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', 'headerDrawerMobile');
    toggle.addEventListener('click', toggleMenu, true);

    var el = drawer();
    if (el) {
      el.id = el.id || 'headerDrawerMobile';
      el.querySelectorAll('[data-header-close]').forEach(function (closeBtn) {
        if (closeBtn.dataset.aHeaderCloseBound === '1') return;
        closeBtn.dataset.aHeaderCloseBound = '1';
        closeBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          closeMenu();
        });
      });
    }
  }

  function bind() {
    bindHamburger();
    bindCollapsibles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', bind);
  window.setTimeout(bind, 0);
  window.setTimeout(bind, 500);
})();
